const isStepCompleted = (route, store) => {
	const steps = [
		'overview',
		'passengers',
		'deck',
		'cabin',
		'order',
	]

	const stepIndex = steps.indexOf(route.meta.step);

	if(stepIndex === -1) {
		return false;
	}

	const requiredSteps = steps.slice(0, stepIndex);

	return requiredSteps.every(step => store.state.product.steps[step]);
}

export default isStepCompleted;


// WEBPACK FOOTER //
// ./src/helpers/is-step-completed.js